import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { Col } from '@thd-olt-component-react/grid';
import {
  arrayOf as arrayType, params,
  shape as shapeType, string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { Image } from '@thd-olt-component-react/image';
import { SupportedDocuments } from './SupportedDocuments';
import { DownloadAdobe } from '../DownloadAdobe/DownloadAdobe';
import './quick-links.scss';

export const getDocumentList = (documents) => {

  let documentList = [
    {
      name: 'Full Product Details',
    },
    {
      name: 'Specifications',
    },
    ...(documents || []),
    {
      name: 'Returns',
      url: 'https://www.homedepot.com/c/Return_Policy'
    }
  ];

  if (documents && documents.length) {
    documentList.push({
      name: 'Info & Guides',
    });
  }
  return documentList;
};

const onClickQuickLink = (document) => {
  const { cardSectionName, scrollToBottom = false, name } = document || {};
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS && (cardSectionName || name)) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('product-overview.card-click',
      { scrollToBottom, cardSectionName, target: name });
  }
};

export const QuickLinks = ({ itemId }) => {
  const { data, loading, error } = useDataModel('product', {
    variables: {
      itemId
    }
  });

  if ((error && !data) || !data || loading) {
    return null;
  }
  const { infoAndGuides } = data?.product?.details || {};
  const documentList = getDocumentList(infoAndGuides).map((doc) => {
    const supported = SupportedDocuments.find((item) => item.name === doc.name);
    if (!supported) {
      return null;
    }
    return {
      ...doc,
      ...supported
    };
  }).filter((doc) => !!doc);

  return (
    <>
      {documentList.map((doc, index) => {
        const {
          cardSectionName, displayName, image, openCard, url
        } = doc;

        let selectedSection = '#';
        if (typeof window !== 'undefined') {
          const productSection = document.getElementById('product-overview') === null
            ? '#product-section-overview' : `#${cardSectionName}`;

          const specificationSection = document.getElementById('specifications') === null
            ? '#product-section-key-feat' : `#${cardSectionName}`;

          selectedSection = cardSectionName === 'specifications' ? specificationSection : productSection;
        }

        const classes = classNames('quick-links-information', {
          'quick-links-information--last': index === documentList.length - 1
        });
        return (
          <div className="quick-links-wrapper" key={`quick-links-${index}`}>
            <Col className={classes}>
              <Col fallback="2">
                <Image src={image} alt="Logo" width="25" height="21" />
              </Col>
              {!openCard
              && (
                <a href={url} rel="noopener noreferrer" target="_blank" onClick={() => { onClickQuickLink(doc); }}>
                  <Col fallback="9">{displayName}</Col>
                </a>
              )}
              {openCard && cardSectionName
              && (
                <a href={selectedSection} onClick={() => { onClickQuickLink(doc); }}>
                  <Col fallback="9">
                    <span role="presentation">{displayName}</span>
                  </Col>
                </a>
              )}
            </Col>
          </div>
        );
      })}
      <DownloadAdobe />
    </>
  );
};

QuickLinks.displayName = 'QuickLinks';

QuickLinks.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    dataSources: stringType(),
    details: {
      infoAndGuides: arrayType(shapeType({
        name: stringType(),
        url: stringType()
      }))
    }
  })
};

QuickLinks.propTypes = {
  itemId: string.isRequired
};
